import React from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    Chip
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import close from "../../assets/icons/close.png";
import expend from "../../assets/icons/expend.png";
import oligasIcn from "../../assets/icons/oligas.png";
import evAutoIcn from "../../assets/icons/automotive.png";
import power from "../../assets/icons/power.png";
import aerospace from "../../assets/icons/aerospace.png";
import industry from "../../assets/icons/industry.png";
import { generateCompanyLogo, getProfilePic } from "../../Utils/Constant";
const industryIcons = {
    "Oil & Gas": oligasIcn,
    "Power & Transmission": power,
    "EV/Automotive": evAutoIcn,
    "Industrial Products": industry,
    "Aerospace & Defence": aerospace
};
export const CompanyProfileDrawer = ({
    open,
    onClose,
    selectedPartner,
    tableData
}) => {
    const industry = selectedPartner?.industryType || "";
    const iconSrc = industryIcons[industry];
    const GenerateImage = (url, id) => {
        const imgUrl = generateCompanyLogo(id, url);

        // const imgUrl = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Organisation_Onboarding_Report/${id}/Company_Logo/image-download/r2QbqB8aOnDng5yR693qTBy60aEQXVbAjWvdFEuC0M0CJvXvv4hpZ3fVZ6UPrfRMOQEmXKkx9fnBFfvxeZmMJQSxnps1mt324E0H?filepath=${url}`;
        if (url) {
            return imgUrl;
        }
    };
    //keyAccountManagerFilePath
    const payload = {
        companyRecId: selectedPartner?.companyRecId,
        compDetails: selectedPartner,
        from: "OrgRepo"
    };
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
                {/* Header Section */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" fontWeight="bold">
                        Company Profile
                    </Typography>
                    <Box>
                        <Link
                            to="/layout/CompanyProfilePage"
                            target="_blank"
                            state={{payload}}
                            onClick={() => {
                                localStorage.setItem(
                                    "CompanyProfilePage",
                                    JSON.stringify(payload)
                                );
                            }}
                        >
                            <IconButton>
                                <img
                                    src={expend}
                                    width={20}
                                    alt="Expand"
                                    onClick={onClose}
                                />
                            </IconButton>
                        </Link>
                        <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                            <img src={close} width={"14px"} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mb: 1 }}
                >
                    Basic Details
                </Typography>
                {/* Basic Details */}
                <Box display="flex" alignItems="center" gap={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Company Name
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography
                                variant="body2"
                                sx={{ display: "flex", alignItems: "center" }}
                            >
                                {selectedPartner?.companyLogo && (
                                    <img
                                        src={GenerateImage(
                                            selectedPartner?.companyLogo,
                                            selectedPartner?.companyRecId
                                        )}
                                        width="30"
                                        height="30"
                                        style={{ marginRight: 10 }}
                                        alt="Company Logo"
                                    />
                                )}

                                {selectedPartner?.companyName || "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Organisation Name
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography
                                variant="body2"
                                sx={{ display: "flex", alignItems: "center" }}
                            >
                                {selectedPartner?.organisationName || "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Industry Type
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography
                                variant="body2"
                                sx={{ display: "flex", alignItems: "center" }}
                            >
                                {iconSrc && (
                                    <img
                                        src={iconSrc}
                                        alt={
                                            selectedPartner?.industryType ||
                                            "Industry Icon"
                                        }
                                        width="14px"
                                        height="14px"
                                        style={{ marginRight: "5px" }}
                                    />
                                )}

                                {selectedPartner?.industryType || "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Key Account Manager
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <img
                                    src=""
                                    alt="KAM"
                                    width={30}
                                    height={30}
                                    style={{ borderRadius: "50%" }}
                                    ref={(img) => {
                                        if (
                                            img &&
                                            selectedPartner?.keyAccountManagerID
                                        ) {
                                            getProfilePic(
                                                selectedPartner?.keyAccountManagerID
                                            ).then((url) => {
                                                img.src = url || "-";
                                            });
                                        }
                                    }}
                                />
                                <Typography variant="body2" ml={1}>
                                    {selectedPartner?.keyAccoutantManager ||
                                        "-"}
                                </Typography>
                            </div>
                        </Grid>
                        {/* 
            <Grid item xs={12} md={5}>
              <Typography variant="body2" color="text.secondary">
                Status
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography variant="body2">
                <Chip
                  label={
                    selectedPartner?.status === "Active" ? "Active" : "Inactive"
                  }
                  color={
                    selectedPartner?.status === "Active" ? "success" : "default"
                  }
                  variant="outlined"
                  size="small"
                />
              </Typography>
            </Grid> */}

                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Presence
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            {selectedPartner?.locationType && ( // Ensure params.value exists
                                <Chip
                                    label={selectedPartner?.locationType}
                                    color={
                                        selectedPartner?.locationType ===
                                        "Domestic"
                                            ? "primary"
                                            : "secondary"
                                    } // Direct inline condition
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        </Grid>
                    </Grid>
                </Box>

                <Divider sx={{ my: 2 }} />
                <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mb: 1 }}
                >
                    Contact Details
                </Typography>
                {/* Contact Details */}
                <Box display="flex" alignItems="center" gap={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                POC Name
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography variant="body2">
                                {selectedPartner?.customerPocName || "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Email
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography
                                variant="body2"
                                sx={{ display: "flex", alignItems: "center" }}
                            >
                                {selectedPartner?.EmailID || "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Contact Number
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography variant="body2">
                                {selectedPartner?.contactNumber || "-"}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Drawer>
    );
};
